import { forwardRef } from 'react';
import cn from 'classnames';
import { AnimatePresence, type HTMLMotionProps, motion } from 'framer-motion';

import {
  type LotteryTicketType,
  type MyLotteryTicketInfo,
} from '@/common/types/lottery';

import { TicketItem } from '../TicketItem/TicketItem';

interface TicketListProps extends HTMLMotionProps<'div'> {
  ticketType: LotteryTicketType;
  variant?: 'border' | 'fill';
  className?: string;
  list?: MyLotteryTicketInfo[];
  itemMotionProps?: HTMLMotionProps<'div'>;
}

const TicketList = forwardRef<HTMLDivElement, TicketListProps>(
  ({ variant, list, ticketType, itemMotionProps, ...props }, ref) => {
    return (
      <motion.div
        ref={ref}
        {...props}
        className={cn(
          'w-full flex flex-col overflow-y-auto hidden-scrollbar',
          props.className,
        )}
      >
        <AnimatePresence>
          {list?.map(({ id, ticket }) => (
            <TicketItem
              key={id}
              ticketType={ticketType}
              ticket={ticket}
              variant={variant}
              {...itemMotionProps}
            />
          ))}
        </AnimatePresence>
      </motion.div>
    );
  },
);

export { TicketList };
